import React, { useEffect, useMemo, useState } from 'react';

import { cn } from '@/lib/utils/cn';

interface ColumnsProps {
  items: React.ReactNode[];
  className?: string;
  multiColumns?: boolean;
}

const Columns: React.FC<ColumnsProps> = ({ items, className = '', multiColumns = false }) => {
  const [columns, setColumns] = useState(1);

  useEffect(() => {
    if (items.length === 1 && !multiColumns) setColumns(1);
    else setColumns(2);
  }, [items.length, multiColumns]);

  const distributedImages = useMemo(() => {
    const cols: React.ReactNode[][] = Array.from({ length: columns }, () => []);
    items.forEach((item, index) => {
      const colIndex = index % columns;
      const column = cols[colIndex];
      if (column) {
        column.push(item);
      }
    });
    return cols;
  }, [items, columns]);

  return (
    <div data-name="Gallery" className={cn('mx-auto flex max-w-184 gap-4 md:gap-6', className)}>
      {distributedImages.map((col, colIndex) => (
        <div key={`column-${colIndex}`} className="flex flex-1 flex-col gap-4 md:gap-6">
          {col.map((item) => {
            const originalIndex = items.indexOf(item);
            return <React.Fragment key={`item-${colIndex}-${originalIndex}`}>{item}</React.Fragment>;
          })}
        </div>
      ))}
    </div>
  );
};

export default Columns;
